import { DirectionalCell } from './directional-cell.model';

export class JobShiftCell extends DirectionalCell {
    jobTitleId: number;
    shiftBlockId: number;
    startHour: number;
}